import { render, staticRenderFns } from "./NameValueFlex.vue?vue&type=template&id=13359866&scoped=true&"
import script from "./NameValueFlex.vue?vue&type=script&lang=js&"
export * from "./NameValueFlex.vue?vue&type=script&lang=js&"
import style0 from "./NameValueFlex.vue?vue&type=style&index=0&id=13359866&prod&lang=css&"
import style1 from "./NameValueFlex.vue?vue&type=style&index=1&id=13359866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13359866",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
